<template>
	<div>
		<el-tooltip effect="dark" placement="right" popper-class="tip-class">
			<div slot="content">
				1、已使用数量、已使用金额的统计不包括已取消的订单使用的优惠券,累计单量、累计金额包括已取消的订单使用的优惠券<br/>
				2、订单金额为营销活动优惠后的金额，运费不计入统计<br/>
				3、未使用且强制结束的优惠券不统计
			</div>
			<img src="~/images/icon/tooltip-icon.png" style="margin-left: 10px;cursor:pointer">
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: 'IconTip',
	data () {
		return {
		}
	},
	created () {

	},
	methods: {

	}
}
</script>
<style lang="stylus" scoped>

</style>
